import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            为什么选择爆料网
          </h2>
          <p className="text-sm text-foreground-500 mt-2">三大核心优势，打造最佳吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="text-center p-8 bg-background-100 rounded-2xl border border-background-200/60 hover:border-primary-200/60 transition-all"
            >
              <div className="w-16 h-16 mx-auto flex items-center justify-center bg-primary-100 rounded-2xl mb-5">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 font-heading mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}